import { METHODS } from '@system/acl/methods';
import type { UserInfo, matchesFn } from '@system/acl/types';

export function trainSchemeMatch(
  matches: Map<string, matchesFn>,
  userInfo: UserInfo,
): void {
  // /** =======================[ Перечень схем поездов ]============================ */
  // Создание
  matches.set(
    METHODS.train_schemas.create,
    conditions =>
      (!!conditions?.considerFpk && userInfo.isFpk) ||
      !conditions?.branchId ||
      conditions?.branchId === userInfo?.branchId,
  );

  // Редактирование
  matches.set(
    METHODS.train_schemas.update,
    conditions =>
      (!!conditions?.considerFpk && userInfo.isFpk) ||
      !conditions?.branchId ||
      conditions?.branchId === userInfo?.branchId,
  );

  // Удаление
  matches.set(
    METHODS.train_schemas.delete,
    conditions =>
      (!!conditions?.considerFpk && userInfo.isFpk) ||
      !conditions?.branchId ||
      conditions?.branchId === userInfo?.branchId,
  );

  // Согласовать
  matches.set(
    METHODS.train_schemas.approveCarriageGroup,
    conditions =>
      (!!conditions?.considerFpk && userInfo.isFpk) ||
      !conditions?.branchId ||
      conditions?.branchId === userInfo?.branchId,
  );

  // Отклонить
  matches.set(
    METHODS.train_schemas.declineCarriageGroup,
    conditions =>
      (!!conditions?.considerFpk && userInfo.isFpk) ||
      !conditions?.branchId ||
      conditions?.branchId === userInfo?.branchId,
  );
}
